import { CUE_INTEGRATION } from '../configs/ApiActionUrl';
import { httpService } from './httpService';
export const cueIntegrationService = {
    getAll,
    add,
    edit,
    update,
}

function getAll(){   
    return httpService.get(CUE_INTEGRATION.GETALL)
        .then(res => {
            if (res.data) {
                return res.data;
            }
            return res;
        });
}

function add(data){
    return httpService.post(CUE_INTEGRATION.ADD, data, {headers: {'Content-Type': 'multipart/form-data'}})
    .then(res => {
        if (res.data) {
            return res.data;
        }
        return res;
    });
}
function edit(id){
    return httpService.get(CUE_INTEGRATION.GET_INDIVIDUAL+"/"+id)
        .then(res => {
            if (res.data) {
                return res.data;
            }
            return res;
        });
}
function update(code, data){
    return httpService.put(CUE_INTEGRATION.UPDATE_INDIVIDUAL+"/"+code, data, {headers: {'Content-Type': 'multipart/form-data'}})   
    .then(res => {
        if (res.data) {
            return res.data;
        }
        return res;
    });
}